import moment from 'moment';

import { timestampFilterCalculations, timestampFilters } from '../constants';

export const reportsActions = {
    clear: 'MAINTENANCE_STANDARD/REPORTS/CLEAR',
    setMappedParetoChartData: 'MAINTENANCE_STANDARD/REPORTS/SET_MAPPED_PARETO_CHART_DATA',
    setJobCategoryChartData: 'MAINTENANCE_STANDARD/REPORTS/SET_JOB_CATEGORY_CHART_DATA',
    setFailureCategoryChartData: 'MAINTENANCE_STANDARD/REPORTS/SET_FAILURE_CATEGORY_CHART_DATA',
    setReportsTimestampFromFilter: 'MAINTENANCE_STANDARD/REPORTS/SET_TIMESTAMP_FROM_FILTER',
    setReportsTimestampToFilter: 'MAINTENANCE_STANDARD/REPORTS/SET_TIMESTAMP_TO_FILTER',
    setReportsTimestamp: 'MAINTENANCE_STANDARD/REPORTS/SET_REPORTS_TIMESTAMP',
    setIsMachineDowntimeDataLoading: 'MAINTENANCE_STANDARD/REPORTS/SET_IS_MACHINE_DOWNTIME_DATA_LOADING',
    setMachineDowntimeData: 'MAINTENANCE_STANDARD/REPORTS/SET_MACHINE_DOWNTIME_DATA',
    setMachineDowntimeTicketsByAsset: 'MAINTENANCE_STANDARD/REPORTS/SET_MACHINE_DOWNTIME_TICKETS_BY_ASSET',
};

const initialState = {
    paretoChartData: [],
    jobCategoryChartData: [],
    failureCategoryChartData: [],
    filters: {
        timestamp: timestampFilters.lastMonth,
        timestampFrom: timestampFilterCalculations[timestampFilters.lastMonth](),
        timestampTo: new Date(),
    },
    isMachineDowntimeDataLoading: true,
    machineDowntimeData: [],
    machineDowntimeTicketsByAsset: [],
};

export const setReportsChartData = (type, payload = []) => {
    return {
        type,
        payload,
    };
};

export const clearReportsChartData = () => {
    return {
        type: reportsActions.clear,
    };
};

export const setReportsTimestampDate = (type, payload = null) => {
    return {
        type,
        payload,
    };
};

export const setReportsTimestamp = (payload = '') => {
    return {
        type: reportsActions.setReportsTimestamp,
        payload,
    };
};

export const setIsMachineDowntimeDataLoading = payload => {
    return {
        type: reportsActions.setIsMachineDowntimeDataLoading,
        payload,
    };
};

export const setMachineDowntimeData = payload => {
    return {
        type: reportsActions.setMachineDowntimeData,
        payload,
    };
};

export const setMachineDowntimeTicketsByAsset = payload => {
    return {
        type: reportsActions.setMachineDowntimeTicketsByAsset,
        payload,
    };
};

export const maintenanceStandardReportsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case reportsActions.clear: {
            return { ...initialState };
        }
        case reportsActions.setMappedParetoChartData: {
            return {
                ...state,
                paretoChartData: payload,
            };
        }
        case reportsActions.setJobCategoryChartData: {
            return {
                ...state,
                jobCategoryChartData: payload,
            };
        }
        case reportsActions.setFailureCategoryChartData: {
            return {
                ...state,
                failureCategoryChartData: payload,
            };
        }
        case reportsActions.setReportsTimestamp: {
            const { newTimestamp, timestampTo, timestampFrom } = payload;

            return {
                ...state,
                filters: {
                    ...state.filters,
                    timestamp: newTimestamp,
                    timestampFrom,
                    timestampTo,
                },
            };
        }

        case reportsActions.setReportsTimestampFromFilter: {
            if (moment(payload).isBefore(moment(state.filters.timestampTo))) {
                return {
                    ...state,
                    filters: {
                        ...state.filters,
                        timestampFrom: payload,
                        timestamp: '',
                    },
                };
            }

            if (moment(payload).isAfter(moment(state.filters.timestampTo))) {
                return {
                    ...state,
                    filters: {
                        ...state.filters,
                        timestampFrom: moment(payload),
                        timestampTo: moment(payload).add(1, 'days'),
                        timestamp: '',
                    },
                };
            }
        }
        case reportsActions.setReportsTimestampToFilter: {
            if (moment(payload).isAfter(moment(state.filters.timestampFrom))) {
                return {
                    ...state,
                    filters: {
                        ...state.filters,
                        timestampTo: payload,
                        timestamp: '',
                    },
                };
            }

            if (moment(payload).isBefore(moment(state.filters.timestampFrom))) {
                return {
                    ...state,
                    filters: {
                        ...state.filters,
                        timestampFrom: moment(payload).subtract(1, 'days'),
                        timestampTo: moment(payload),
                        timestamp: '',
                    },
                };
            }
        }

        case reportsActions.setIsMachineDowntimeDataLoading: {
            return {
                ...state,
                isMachineDowntimeDataLoading: payload,
            };
        }
        case reportsActions.setMachineDowntimeData: {
            return {
                ...state,
                machineDowntimeData: payload,
            };
        }
        case reportsActions.setMachineDowntimeTicketsByAsset: {
            return {
                ...state,
                machineDowntimeTicketsByAsset: payload,
            };
        }

        default:
            return state;
    }
};

export const selectMMaintReportsFilters = state => state.maintenanceStandard?.reports?.filters;
export const selectIsMachineDowntimeDataLoading = state => state.maintenanceStandard?.reports?.isMachineDowntimeDataLoading;
export const selectMachineDowntimeData = state => state.maintenanceStandard?.reports?.machineDowntimeData;
export const selectMachineDowntimeTicketsByAsset = state => state.maintenanceStandard?.reports?.machineDowntimeTicketsByAsset;

export const selectMMaintReportsDateTo = state => state.maintenanceStandard?.reports?.filters?.timestampTo;
export const selectMMaintReportsDateFrom = state => state.maintenanceStandard?.reports?.filters?.timestampFrom;
